/* Elimest ortak davranışlar: giriş animasyonları ve duyuru çubuğu. Harici kütüphane yok. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Giriş animasyonları ---------- */
  var observer = null;
  function showAll(root) {
    (root || document).querySelectorAll('[data-e-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
  function observeReveals(root) {
    var items = (root || document).querySelectorAll('[data-e-reveal]:not(.is-visible)');
    if (!items.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      showAll(root);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
    }
    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- Duyuru çubuğu ---------- */
  function initAnnouncement(bar) {
    if (bar.dataset.eReady) return;
    bar.dataset.eReady = '1';
    var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-e-slide]'));
    if (slides.length < 2) return;
    var prev = bar.querySelector('[data-e-prev]');
    var next = bar.querySelector('[data-e-next]');
    var live = bar.querySelector('[data-e-live]');
    var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    var index = 0;
    var timer = null;
    var paused = false;

    function go(to, dir) {
      var current = slides[index];
      index = (to + slides.length) % slides.length;
      var target = slides[index];
      if (current === target) return;
      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      current.dataset.dir = dir > 0 ? 'out-up' : 'out-down';
      target.style.transition = 'none';
      target.dataset.dir = dir > 0 ? 'in-up' : 'in-down';
      void target.offsetWidth;
      target.style.transition = '';
      target.classList.add('is-active');
      target.removeAttribute('aria-hidden');
      slides.forEach(function (s) {
        s.querySelectorAll('a').forEach(function (a) {
          a.tabIndex = s === target ? 0 : -1;
        });
      });
      if (live) live.textContent = target.textContent.trim();
    }
    function start() {
      stop();
      if (reduceMotion.matches || paused) return;
      timer = setInterval(function () {
        go(index + 1, 1);
      }, speed);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }
    if (prev) prev.addEventListener('click', function () { go(index - 1, -1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1, 1); start(); });
    bar.addEventListener('mouseenter', function () { paused = true; stop(); });
    bar.addEventListener('mouseleave', function () { paused = false; start(); });
    bar.addEventListener('focusin', function () { paused = true; stop(); });
    bar.addEventListener('focusout', function () { paused = false; start(); });
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
    start();
  }

  function init(root) {
    observeReveals(root);
    (root || document).querySelectorAll('[data-e-announcement]').forEach(initAnnouncement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  /* Güvenlik ağı: gözlemci tetiklenmezse içerik gizli kalmasın */
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('[data-e-reveal]:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    }, 1200);
  });

  /* Tema editörü */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    if (window.Shopify && window.Shopify.designMode) showAll(e.target);
  });

  window.Elimest = window.Elimest || {};
  window.Elimest.init = init;
})();
